/**
 * 药品模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 搜索物料
export const getMaterials = (params) => {
  return req.get('/hosp/drug/getMaterials', params);
}
// 获取药品库存列表
export const drugList = (params) => {
  return req.get('/hosp/drug/list', params);
}

// 获取药品库存详情
export const drugEdit = (drugId) => {
  return req.get('/hosp/drug/' + drugId);
}

// 获取药品目录列表
export const queryDrugSpu = (params) => {
  return req.get('/hosp/drug/queryDrugSpu', params);
}

// 根据药品种类查询药品
export const drugListByKindId = (params) => {
  return req.get('/hosp/drug/selectListByKindId', params);
}

// 根据药品货号查询药品信息
export const drugListByArtNo = (params) => {
  return req.get('/hosp/drug/selectListByArtNo', params);
}

// 转换药品类型
export const drugTypeConvert = (params) => {
  return req.post('/hosp/drug/drugTypeConvert', params);
}

//修改价格和编码
export const edit = (params) => {
  return req.post('/hosp/drug/edit', params);
}

// 修改货位
export const editPosition = (params) => {
  return req.post('/hosp/drug/edit/position', params);
}

// 改变追溯码状态
export const changeTraceStatus = (params) => {
  return req.post('/hosp/drug/editHospDrugById', params);
}

// 改变贵重药品状态
export const changeValuableDrugStatus = (params) => {
  return req.post('/hosp/drug/updateValuableFlag', params);
}

//产看库存
export const getInventoryApi = (params) => {
  return req.post('/hosp/drug/getDrugs', params);
}

//查询商品库存以及禁用标识
export const searchProperty = (params) => {
  return req.post('/hosp/goods/searchProperty', params);
}

//修改药品医保属性
export const editMedicalInsuranceType = (params) =>{
  return req.post('/hosp/drug/edit/editMedicalInsuranceType', params);
}

//同步库存
export const fireSync = (params) =>{
  return req.get('/sync/admin/fireSync', params,'/xl');
}